import React from 'react';
import ReactDOM from 'react-dom';
import Roots from "./Roots"
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  // <BrowserRouter basename={window.location.pathname || ''}>
  <BrowserRouter>
      <Roots />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
